// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.image-container {
  display: flex;
  flex-direction: row;  /* Align children horizontally */
  align-items: flex-start; /* Align items to the start of the cross axis */
  overflow-x: auto; /* Allows horizontal scrolling if images overflow */
}

.image-size {
  width: 50px; /* Fixed width for each image */
  height: auto; /* Maintains the aspect ratio of the image */
  margin-right: 5px; /* Adds space between images */
}

.checkbox-container2 {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(40px, 1fr)); /* Adjust the minmax value as needed */
  gap: 10px; /* Optional: Adjust spacing between checkboxes */
}

.checkbox-container2 label {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  cursor: pointer;
  width: 40px;  /* Adjust width as needed */
  height: 30px;  /* Adjust height as needed */
  border: 2px solid #005792;
  border-radius: 4px;
  background-color: #f0f0f0;
  position: relative;
  -webkit-user-select: none;
          user-select: none;
}

.checkbox-container2 input[type="checkbox"] {
  appearance: none;
  cursor: pointer;
}

.checkbox-container2 input[type="checkbox"]:checked + label {
  background-color: #007acc;
  color: white;
}

.checkbox-container2 input[type="checkbox"]:checked + label::after {
  font-size: 14px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: white;
}`, "",{"version":3,"sources":["webpack://./src/TrophicFeedsPanel.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB,GAAG,gCAAgC;EACtD,uBAAuB,EAAE,+CAA+C;EACxE,gBAAgB,EAAE,mDAAmD;AACvE;;AAEA;EACE,WAAW,EAAE,+BAA+B;EAC5C,YAAY,EAAE,4CAA4C;EAC1D,iBAAiB,EAAE,8BAA8B;AACnD;;AAEA;EACE,aAAa;EACb,2DAA2D,EAAE,sCAAsC;EACnG,SAAS,EAAE,gDAAgD;AAC7D;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,WAAW,GAAG,2BAA2B;EACzC,YAAY,GAAG,4BAA4B;EAC3C,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,YAAY;AACd","sourcesContent":[".image-container {\n  display: flex;\n  flex-direction: row;  /* Align children horizontally */\n  align-items: flex-start; /* Align items to the start of the cross axis */\n  overflow-x: auto; /* Allows horizontal scrolling if images overflow */\n}\n\n.image-size {\n  width: 50px; /* Fixed width for each image */\n  height: auto; /* Maintains the aspect ratio of the image */\n  margin-right: 5px; /* Adds space between images */\n}\n\n.checkbox-container2 {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(40px, 1fr)); /* Adjust the minmax value as needed */\n  gap: 10px; /* Optional: Adjust spacing between checkboxes */\n}\n\n.checkbox-container2 label {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n  cursor: pointer;\n  width: 40px;  /* Adjust width as needed */\n  height: 30px;  /* Adjust height as needed */\n  border: 2px solid #005792;\n  border-radius: 4px;\n  background-color: #f0f0f0;\n  position: relative;\n  user-select: none;\n}\n\n.checkbox-container2 input[type=\"checkbox\"] {\n  appearance: none;\n  cursor: pointer;\n}\n\n.checkbox-container2 input[type=\"checkbox\"]:checked + label {\n  background-color: #007acc;\n  color: white;\n}\n\n.checkbox-container2 input[type=\"checkbox\"]:checked + label::after {\n  font-size: 14px;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  color: white;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
